import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import memo from "set-state-compare/build/memo"
import React from "react"

/**
 * @typedef {object} ComponentsNavProps
 * @property {unknown} className
 */

/** @typedef {object} ComponentsNavState */

/**
 * @extends {ShapeComponent<ComponentsNavProps, ComponentsNavState>}
 */
class ComponentsNav extends ShapeComponent {
  render() {
    const {className, ...restProps} = this.props

    return (
      <div className={classNames("components--nav", className)} {...restProps} />
    )
  }
}

export default memo(shapeComponent(ComponentsNav))
